import React from "react";
import { useLocalStorage } from "usehooks-ts";

type TContext = {
  isLogin: boolean;
  token: string | null;
  toggleLogin: (token?: string | null) => void;
  logout: () => void;
};

const LoginContext = React.createContext<TContext>({
  isLogin: false,
  token: null,
  toggleLogin: () => {},
  logout: () => {},
});

export const LoginContextProvider: React.FC = ({ children }) => {
  const [isLogin, setIsLogin] = useLocalStorage("isLogin", false);
  const [token, setToken] = useLocalStorage<string | null>("authToken", null);

  function logout() {
    setToken(null);
    setIsLogin(false);
  }

  function toggleLogin(newToken?: string | null) {
    if (newToken) {
      setToken(newToken);
      setIsLogin(true);
    } else {
      logout(); // Avoid duplication
    }
  }

  const loginValue: TContext = {
    isLogin,
    token,
    toggleLogin,
    logout,
  };

  return <LoginContext.Provider value={loginValue}>{children}</LoginContext.Provider>;
};

export default LoginContext;
